import React, { useEffect } from 'react';
import { withRouter } from "react-router-dom";
import { usePagesState, GetHelpContent } from '../../context/PagesContext';


//global css
import "../../static/css/global.css";

const PrivacyPolicy = () => {
  const context = usePagesState();

  useEffect(() => {
    GetHelpContent(context.setGetContent)
  }, []);

  useEffect(() => {
    if (context.Gethelpcontent.getHelp.data && context.Gethelpcontent.getHelp.data.content) {
      let htmlData = context.Gethelpcontent.getHelp.data.content;
      document.getElementById("content").innerHTML = htmlData;

    }
  }, [context.Gethelpcontent.getHelp.data])

  return (
    <>
      <div className='maincontent'>
        <div className='content' id='content'>
        </div>
      </div>
    </>
  );

}

export default withRouter(PrivacyPolicy);